import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const BroomIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="m21.4 21.4-1.3-5.1h.2c.3 0 .6-.1.7-.3l.3-.7V13c0-.8-.3-1.5-.9-2-.5-.6-1.3-1-2.1-1h-5.4V2.6c0-.6-.4-1-.9-1a1 1 0 0 0-1 1V10H5.6c-.8 0-1.6.3-2 .8-.6.7-1 1.4-1 2.2v2.2c0 .5.5 1 1 1l-1.7 5c-.1.4-.1.8.1 1 .2.3.5.4.8.4h17.8c.3 0 .5-.1.8-.3v-1ZM4.6 13.1c0-.3.1-.6.3-.7.2-.2.5-.3.7-.3h12.8c.3 0 .5 0 .7.3.1.1.3.4.3.7v1.2H4.6V13Zm12.1 7.6v-.1l-.5-2a1 1 0 0 0-1.2-.8 1 1 0 0 0-.8 1.2l.5 1.7H4.2l1.5-4.3h12.4l1.1 4.3h-2.5Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default BroomIcon;
